import React from "react";

const K = 520;
const px = (lon, lat) => [((lon - 5.8) * 0.62 * K + 30).toFixed(1), ((51.98 - lat) * K + 10).toFixed(1)];
const P = (lon, lat) => px(lon, lat).join(",");

const rhine = [
  [6.14, 51.88], [6.22, 51.82], [6.33, 51.78], [6.40, 51.75], [6.47, 51.71], [6.53, 51.67],
  [6.58, 51.63], [6.64, 51.64], [6.68, 51.58], [6.72, 51.50], [6.74, 51.43], [6.72, 51.36],
  [6.74, 51.30], [6.77, 51.23], [6.80, 51.16], [6.86, 51.10],
];
const border = [[5.93, 51.98], [5.93, 51.86], [5.97, 51.77], [6.05, 51.66], [6.15, 51.55], [6.18, 51.45], [6.14, 51.33], [6.07, 51.22], [6.05, 51.10]];

const core = [
  { n: "Kranenburg", lon: 6.01, lat: 51.79, hq: true, left: true },
  { n: "Kleve", lon: 6.14, lat: 51.79 },
  { n: "Emmerich", lon: 6.25, lat: 51.84 },
  { n: "Goch", lon: 6.16, lat: 51.68 },
  { n: "Geldern", lon: 6.33, lat: 51.52 },
  { n: "Xanten", lon: 6.45, lat: 51.66 },
  { n: "Bocholt", lon: 6.62, lat: 51.84 },
  { n: "Wesel", lon: 6.62, lat: 51.66 },
];
const wider = [
  { n: "Dorsten", lon: 6.96, lat: 51.66 },
  { n: "Krefeld", lon: 6.56, lat: 51.33 },
  { n: "Düsseldorf", lon: 6.78, lat: 51.23 },
];

const Town = ({ t, muted }) => {
  const [x, y] = px(t.lon, t.lat);
  return (
    <g>
      <circle cx={x} cy={y} r={t.hq ? 6 : 4} fill={t.hq ? "#e9a24b" : muted ? "#7a98bd" : "#152740"} stroke="#fff" strokeWidth="2" />
      <text x={t.left ? +x - 9 : +x + 9} y={+y + 4} textAnchor={t.left ? "end" : "start"} fontSize="12" fontWeight={t.hq ? 700 : 500} fill={muted ? "#51708f" : "#152740"} fontFamily="Manrope, Arial, sans-serif">
        {t.n}
      </text>
    </g>
  );
};

export const ServiceAreaMap = () => {
  const [cx, cy] = px(6.33, 51.69);
  const [wx, wy] = px(6.60, 51.48);
  return (
    <figure className="mt-5 rounded-2xl border border-brand-100 bg-brand-50/60 p-4" data-testid="service-area-map">
      <svg viewBox="0 0 500 460" className="w-full h-auto" role="img" aria-label="Karte des Einzugsgebiets: Kreis Kleve und Umgebung bis zum Raum Düsseldorf, Krefeld und Dorsten">
        <defs>
          <pattern id="nl" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="8" stroke="#c9d8ea" strokeWidth="2" />
          </pattern>
        </defs>
        <polygon points={`0,0 ${border.map(([lo, la]) => P(lo, la)).join(" ")} 0,450`} fill="url(#nl)" opacity="0.45" />
        <text x="36" y="330" fontSize="11" fill="#7a98bd" fontFamily="Manrope, Arial, sans-serif" letterSpacing="2">NIEDERLANDE</text>
        <ellipse cx={wx} cy={wy} rx="215" ry="175" fill="#152740" opacity="0.07" />
        <ellipse cx={wx} cy={wy} rx="215" ry="175" fill="none" stroke="#152740" strokeOpacity="0.25" strokeDasharray="5 5" />
        <ellipse cx={cx} cy={cy} rx="165" ry="112" fill="#e9a24b" opacity="0.18" />
        <ellipse cx={cx} cy={cy} rx="165" ry="112" fill="none" stroke="#e9a24b" strokeWidth="2" />
        <polyline points={rhine.map(([lo, la]) => P(lo, la)).join(" ")} fill="none" stroke="#7fb3e0" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" />
        <text x={+px(6.72, 51.46)[0] + 8} y={+px(6.72, 51.46)[1] + 4} fontSize="11" fill="#5a93c4" fontStyle="italic" fontFamily="Manrope, Arial, sans-serif">Rhein</text>
        {wider.map((t) => <Town key={t.n} t={t} muted />)}
        {core.map((t) => <Town key={t.n} t={t} />)}
      </svg>
      <figcaption className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-[12px] text-brand-600">
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-accent2" /> Sitz Kranenburg</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full border-2 border-accent2 bg-accent2/20" /> Kerngebiet Kreis Kleve</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full border border-dashed border-brand-900/50 bg-brand-900/10" /> Erweitertes Einzugsgebiet</span>
      </figcaption>
    </figure>
  );
};
